// This icon file is generated automatically.
var PLaptopOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M13.95 12.2l-.94-3.32V1.62a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v7.25L.06 12.2a.5.5 0 00.47.68h12.95a.5.5 0 00.47-.68zM2.13 2.25h9.75v6.17H2.13V2.25zm3.57 9.5l.13-.58h2.34l.13.58H5.7zm3.5 0l-.3-1.35a.13.13 0 00-.12-.1H5.22c-.06 0-.1.04-.12.1l-.3 1.35H1.36l.66-2.33h9.97l.66 2.33H9.2z", "fill-rule": "nonzero" } }] }, "name": "p-laptop", "theme": "outlined" };
export default PLaptopOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLaptopOutlined.js
// module id = 3479
// module chunks = 0